import type { NextPage, GetServerSideProps } from 'next'

import type { ListItem as IBoardListItem } from '@/modules/board'
import type {SummaryItem} from "@/modules/project/interface";

import BannerComponent from './Banner'
import SummaryBox from './SummaryBox'
import BoardSummaryTab from './BoardSummaryTab'
import ParticipationBox from './ParticipationBox'


interface IProps {
  publishedItems: SummaryItem[]
  draftItems: SummaryItem[]
  noticeItems: IBoardListItem[]
  documentItems: IBoardListItem[]
}

const Component: NextPage<IProps> = ({ publishedItems, draftItems, noticeItems, documentItems }) => {
  return (
    <div className='flex flex-col items-center'>
      <BannerComponent />
      <div className='w-[1200px] min-w-[1200px] max-w-[1200px] flex flex-col items-center justify-center'>
        <div className='flex justify-center w-full my-12 space-x-16'>
          <SummaryBox title="공고 · 공람" moreLink='/opinion/decision' detailLink={"/opinion/decision"} items={publishedItems} />
          <SummaryBox title="평가서(초안) 공람" moreLink='/project?step=draft' detailLink={"/project"} items={draftItems} />
        </div>
        <div className='flex items-stretch justify-center w-full my-12 space-x-16'>
          <div className='flex flex-[2_2_0%]'>
            <BoardSummaryTab noticeItems={noticeItems} documentItems={documentItems} />
          </div>
          <div className='flex flex-1'>
            <ParticipationBox />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component
